import PageWrapper from 'components/utils/PageWrapper';
import Dashboard from 'pages/Dashboard';

export const dashboardRoutes = {
    path: '/',
    element: (
        <PageWrapper titleId="common_dashboard">
            <Dashboard />
        </PageWrapper>
    ),
};
